import get from 'lodash.get';

const getSupportedLocales = (state) => get(state, 'ws.supportedLocales', []);

export default getSupportedLocales;
